require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-record-breaking-penthouse-one-five-six.json") })
        }
      }, "path---journal-record-breaking-penthouse-one-five-six");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-record-breaking-penthouse-one-five-six!./.cache/json/journal-record-breaking-penthouse-one-five-six.json
// module id = 527
// module chunks = 231608221292675